import { render, staticRenderFns } from "./staffList.vue?vue&type=template&id=b2d37f48&scoped=true&"
import script from "./staffList.vue?vue&type=script&lang=js&"
export * from "./staffList.vue?vue&type=script&lang=js&"
import style0 from "./staffList.vue?vue&type=style&index=0&id=b2d37f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d37f48",
  null
  
)

export default component.exports